export const BILLING_TYPES = [
    {
        view: 'Credit/Debit card',
        data: 'CARD'
    },
    {
        view: 'Bank account',
        data: 'BANK_ACCOUNT'
    }
];




// WEBPACK FOOTER //
// ./src/constants/billing-types.js